module.exports = __webpack_public_path__ + "app/kiss-seller/sub-entity-NPBitYHc.html";